import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import {
  Media,
  descriptionRules,
  purposeRules,
  purposeItems,
} from '@/models/media.model';
import { Mutations } from '@/store';
import { PropType, ref, onMounted, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaField',
  props: {
  modelValue: {
    type: Object as PropType<Media>,
    required: true,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();
const media = ref<Media>({ ...props.modelValue });
const { t } = useI18n();

const emit = __emit;

function update() {
  emit('update:modelValue', media.value);
  emit('change', media.value);
}

const currentValue = { ...props.modelValue };

onMounted(() => {
  Object.assign(media.value, { ...props.modelValue });
});

watch(
  () => props.modelValue,
  () => {
    Object.assign(media.value, { ...props.modelValue });
  },
  { deep: true },
);

function getSimpleValue(i: Media) {
  return {
    title: i.description,
    purpose: i.purpose,
    language: i.language,
  };
}

const isDirty = computed<boolean>(() => {
  const isDirty =
    JSON.stringify(getSimpleValue(media.value)) !==
    JSON.stringify(getSimpleValue(currentValue));

  store.commit(Mutations.SetDirtyState, isDirty);

  return isDirty;
});

const languageItems = [
  { title: t('media.all'), value: 'all' },
  { title: 'Nederlands', value: 'nl' },
  { title: 'English', value: 'en' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "11" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: media.value.description,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((media.value.description) = $event)),
                update
              ],
              rules: _unref(descriptionRules),
              label: _ctx.$t('media.description'),
              required: ""
            }, null, 8, ["modelValue", "rules", "label"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            (isDirty.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              modelValue: media.value.purpose,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((media.value.purpose) = $event)),
                update
              ],
              rules: _unref(purposeRules),
              items: _unref(purposeItems),
              label: _ctx.$t('media.purpose'),
              required: ""
            }, null, 8, ["modelValue", "rules", "items", "label"])
          ]),
          _: 1
        }),
        (media.value.file && media.value.id !== -1)
          ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: media.value.file.language,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((media.value.file.language) = $event)),
                    update
                  ],
                  items: languageItems,
                  label: _ctx.$t('media.language'),
                  required: ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (media.value.id === -1 && media.value.file?.uuid)
          ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: media.value.file.language,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((media.value.file.language) = $event)),
                    update
                  ],
                  items: languageItems,
                  label: _ctx.$t('media.language'),
                  title: "(File)",
                  required: "",
                  readonly: "",
                  disabled: ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (media.value.id === -1 && !media.value.file?.uuid)
          ? (_openBlock(), _createBlock(_component_v_col, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: media.value.language,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((media.value.language) = $event)),
                    update
                  ],
                  items: languageItems,
                  label: _ctx.$t('media.language'),
                  title: "(Media)",
                  required: ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})